import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import Skills from '@/components/skills.vue';
import addMonths from "date-fns/add_months";
import { getCompany, getTeamByCompany } from './core/cacheService'
export default {
    namespaced: true,
    state: {
        organization1level:[],
        teamHeight:"",
        datachart:[],
        max_x:[],
        max_y:0,
        median_excel:0,
        median_improves:0,
        skillProficiencyAndDeficiency:[],
        skill:[],
        attributes:[],
        dataAll:[],
        skillProficiencyAndDeficiencyAll:[],
        statusTeam:false,
        skillProficiencyAndDeficiencyByteam:[],
        loading:true,
        highest:0,
        lowest:0,
        skillexcel:[],
        skillimprove:[],
        userData:{},
        team_id:'all',
        dataAllArr:[],
        rank:false,
        changetime:false,
    },

    mutations: {
          setOrganization1level(state: any, value: any) {
            state.organization1level = value
          },
          setteamHeight(state: any, value: any) {
            state.teamHeight = value
          },
          setdatachart(state: any, value: any) {
            state.datachart = value
          },
          setmax_x(state: any, value: any) {
            state.max_x = value
          },
          setmax_y(state: any, value: any) {
            state.max_y = value
          },
          setskillProficiencyAndDeficiency(state: any, value: any) {
            state.skillProficiencyAndDeficiency = value
          },
          setSkill(state: any, value: any){
            state.skill = value
          },
          setAttributes(state: any, value: any){   
            state.attributes = value
          },
          setdataAll(state: any, value: any){   
            state.dataAll = value
          },
          setskillProficiencyAndDeficiencyAll(state: any, value: any){
            state.skillProficiencyAndDeficiencyAll = value
          },
          setskillProficiencyAndDeficiencyByteam(state: any, value: any){
            state.skillProficiencyAndDeficiencyByteam = value
          },
          
          sethighest(state: any, value: any){
            if(state.rank==true){
                let count=0
            for(const i in value){
                count++
                value[i].rank_highest=count
            } 

            }
            
            state.highest = value
          },
          setlowest(state: any, _value: any){
            state.lowest = _value
          },
          setskillimprove(state: any, value: any){
            state.skillimprove = value
          },
          setskillexcel(state: any, value: any){
            state.skillexcel= value
          }
          
        
          
    },
    actions: {
        async getOrganization1level({ commit, state, rootState,dispatch }: any) {
            state.loading=true
            const organization1level = {}
            let team={}
            let topmostArr: Array<any> = [];
            let teamHeight:any
            await dispatch('main/getteam',true,{root:true})
            team = await getTeamByCompany(rootState.authen.user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
        
            
            for(const i in team){
                team[i].key=i
                if(!team[i].parent){
                  topmostArr.push(i)
                }
            }
           
            teamHeight = topmostArr[0]
            if(topmostArr.length > 1){
              teamHeight = _.find(topmostArr, (value) => {
              const chk_topmost = _.find(team, { parent: value });
              return !!chk_topmost;
              });
            }
            //console.log("teamHeight",teamHeight)
            await firebase.firestore().collection('organization1level').where("company", "==", rootState.authen.user.company).get()
            .then((querySnapshot)=> {
                    querySnapshot.forEach((doc)=> {
                      const data=doc.data()
                          if(!organization1level[data.team_id]){
                            organization1level[data.team_id]=data.parent
                          }               
                    });
                    commit('setOrganization1level', organization1level)
                    //console.log("teamHeight",teamHeight)
                    commit('setteamHeight', teamHeight)
                    
                    dispatch('getData')
            });
        },
        // async getData({ commit, state,rootState,dispatch }: any,team_id:any) {
        //     state.loading=true
        //     const masterSuggest={
        //         "Truly":4,
        //         "Exceeding":3,
        //         "Meets":2,
        //         "Needs":1,
        //     }
        //     if(team_id){
        //         const datateam=state.dataAll.excel
        //         const datateamImproves=state.dataAll.improves
                
        //         const data:any=[]
        //         let team=state.organization1level[team_id]
        //         if(!team){
        //             team={[team_id]:true}
        //         }
        //         if(team_id=="all"){
        //             team=state.organization1level[state.teamHeight]
        //         }
        //         let skillProficiencyAndDeficiency:Array<any>=[]
        //         let skillData:Array<any>=[]
        //         let total_feedback=0
        //         const improves_frequency={}
        //         const skill_frequency={}
        //         const average_proficiency_rating={}
        //         const average_deficiency_rating={}
        //         const median_proficiency_rating:any=[]
        //         const median_deficiency_rating:any=[]
        //         const skillMaster:Array<any>=[]
        //         for(const i in team){
        //             if(datateam[i]){
       
        //                 for(const j in datateam[i]){
           
        //                     if(j!="total"){
        //                         if(!skill_frequency[j]){
        //                             skill_frequency[j]={point:0,attributes_selected:0,sum_ratings:0,tags:[],selected:{}}
        //                         }
        //                         skill_frequency[j].point=skill_frequency[j].point+datateam[i][j].point
        //                         skill_frequency[j].attributes_selected=skill_frequency[j].attributes_selected+datateam[i][j].attributes_selected
        //                         skill_frequency[j].sum_ratings=skill_frequency[j].sum_ratings+datateam[i][j].sum_ratings
        //                     }else{
        //                         total_feedback=total_feedback+datateam[i].total
        //                     }
        //                     if(datateam[i][j].selected){
        //                         for(const k in datateam[i][j].selected){
        //                             if(!skill_frequency[j]['selected'][k]){
        //                                 skill_frequency[j]['selected'][k]=0
        //                             }
        //                             skill_frequency[j]['selected'][k]=skill_frequency[j]['selected'][k]+datateam[i][j].selected[k]
                                    
        //                         }
        //                     }
        //                     if(datateam[i][j].tags){
        //                         for(const tagId in datateam[i][j].tags){
        //                             datateam[i][j].tags[tagId].scorePercentage=(datateam[i][j].tags[tagId].score)/(datateam[i][j].tags[tagId].total*6)*100
        //                         }
        //                         skill_frequency[j]['tags'].push(...datateam[i][j].tags)
        //                     }
                    
                            
        //                 }
        //             }
        //             if(datateamImproves[i]){
        //                 for(const j in datateamImproves[i]){
        //                     if(j!="total"){
        //                         if(!improves_frequency[j]){
        //                             improves_frequency[j]={point:0,attributes_selected:0,tags:[],selected:{}}
        //                         }
        //                         improves_frequency[j].point=improves_frequency[j].point+datateamImproves[i][j].point
        //                         improves_frequency[j].attributes_selected=improves_frequency[j].attributes_selected+datateamImproves[i][j].attributes_selected
        //                     }
        //                     if(datateamImproves[i][j].tags){
                                      
        //                         for(const tagId in datateamImproves[i][j].tags){
        //                             datateamImproves[i][j].tags[tagId].scorePercentage=(datateamImproves[i][j].tags[tagId].score)/(datateamImproves[i][j].tags[tagId].total*6)*100
        //                         }
        //                         improves_frequency[j]['tags'].push(...datateamImproves[i][j].tags)
        //                     }
                           
        //                     if(datateamImproves[i][j].selected){
        //                         for(const k in datateamImproves[i][j].selected){
        //                             if(!improves_frequency[j]['selected'][k]){
        //                                 improves_frequency[j]['selected'][k]=0
        //                             }
        //                             improves_frequency[j]['selected'][k]=improves_frequency[j]['selected'][k]+datateamImproves[i][j].selected[k]
                                    
        //                         }
        //                     }
                            
        //                 }
        //             }
                 
        //         }
               
        //         for(const i in skill_frequency){
        //             if(!average_proficiency_rating[i]){
        //                 average_proficiency_rating[i]={name:i,size:0,rating:0,impact_on_performance:0,type:'excel'}
        //             }
        //             average_proficiency_rating[i]['impact_on_performance'] = skill_frequency[i].sum_ratings / skill_frequency[i].point
        //             average_proficiency_rating[i]['size'] = skill_frequency[i].attributes_selected / skill_frequency[i].point
        //             average_proficiency_rating[i]['rating']=(skill_frequency[i].point/total_feedback)*100
        //             median_proficiency_rating.push(average_proficiency_rating[i]['rating'])
        //             const skillfind=_.find(skillMaster,function(o) { return o == i; });
        //             if(!skillfind){
        //                 skillMaster.push(i)
        //             }
                   
                
        //         }
        //         if(median_proficiency_rating.length>0){
        //         await dispatch('median',{rating:median_proficiency_rating,type:"median_excel"})
        //         }
                
        //         for(const i in improves_frequency){
        //             if(!average_deficiency_rating[i]){
        //                 average_deficiency_rating[i]={name:i,size:0,rating:0,impact_on_performance:0}
        //             }
                    
        //             average_deficiency_rating[i]['impact_on_performance'] = skill_frequency[i]?skill_frequency[i].sum_ratings / skill_frequency[i].point:0
        //             average_deficiency_rating[i]['size']=improves_frequency[i].attributes_selected / improves_frequency[i].point
        //             average_deficiency_rating[i]['rating']=(improves_frequency[i].point/total_feedback)*100
        //             // avg_selected_attributes[i]=total_attributes_selected / improves_frequency[i]
        //             //data.push({name:i,size:average_deficiency_rating[i]['size'],x:average_deficiency_rating[i]['rating'],y:average_deficiency_rating[i]['impact_on_performance'],type:'improves'})
        //             median_deficiency_rating.push(average_deficiency_rating[i]['rating'])
        //             const skillfind=_.find(skillMaster,function(o) { return o == i; });
        //             if(!skillfind){
        //                 skillMaster.push(i)
        //             }
                    
        //         }
        //         const sortData1 = _.orderBy(average_deficiency_rating, [
        //             'rating'
        //           ], ['desc']);
        //          const top_1 = _.slice(sortData1, 0, 1)
        //          for(const i in improves_frequency){
        //             // console.log("average_deficiency_rating[i]['rating']",i,average_deficiency_rating[i]['rating'])
        //             data.push({name:i,size:average_deficiency_rating[i]['size'],x:((average_deficiency_rating[i]['rating']*100/top_1[0]['rating'])*-1),y:average_deficiency_rating[i]['impact_on_performance'],type:'improves'})
        //          }
        //         if(median_deficiency_rating.length>0){
        //             await dispatch('median',{rating:median_deficiency_rating,type:"median_improves"})
        //         }
        //         const attributes:any={}
        //         const sortData = _.orderBy(average_proficiency_rating, [
        //             'rating'
        //           ], ['desc']);
        //          const top1 = _.slice(sortData, 0, 1)
        //         for(const id in skillMaster){
        //         const i= skillMaster[id]  
        //         let members:Array<any>=[]
        //         let relative_skill_proficiency_score=0
        //         let bar_width=0
        //         if(average_proficiency_rating[i]){

        //             const max_proficiency_rating= _.orderBy(average_proficiency_rating,[function (o) {return o.rating;},],["desc"])[0];
        //             const skill_proficiency_rating=average_proficiency_rating[i]?average_proficiency_rating[i]['rating']:0
        //             relative_skill_proficiency_score = skill_proficiency_rating / state.median_excel
        //             bar_width = ( skill_proficiency_rating/ max_proficiency_rating.rating) * 100
        //             data.push({name:i,size:average_proficiency_rating[i]['size'],x:(average_proficiency_rating[i]['rating']*100/top1[0]['rating']),y:average_proficiency_rating[i]['impact_on_performance'],type:'excel',bar_width_excel:bar_width,relative_skill_proficiency_score:relative_skill_proficiency_score})
        //             // data.push({name:i,size:average_proficiency_rating[i]['size'],x:average_proficiency_rating[i]['rating'],y:average_proficiency_rating[i]['impact_on_performance'],type:'excel',bar_width_excel:bar_width,relative_skill_proficiency_score:relative_skill_proficiency_score})
                    
        //         }
           
        //         const max_deficiency_rating= _.orderBy(average_deficiency_rating,[function (o) {return o.rating;},],["desc"])[0];
        //         let relative_skill_deficiency_score=0
        //         let bar_width_deficiency=0
        //         if(average_deficiency_rating[i]){
        //             relative_skill_deficiency_score = average_deficiency_rating[i]['rating'] / state.median_improves
        //             bar_width_deficiency = ( average_deficiency_rating[i]['rating']/ max_deficiency_rating.rating) * 100
        //         }
          
        //         if(skill_frequency[i]&&skill_frequency[i].selected){
        //             for(const j in skill_frequency[i].selected){
                        
        //                 if(!attributes[i]){
        //                     attributes[i]=[]
        //                 }
        //                 let excelsScore=0
        //                 if(skill_frequency[i].selected[j]){
        //                  excelsScore=(skill_frequency[i].selected[j]/skill_frequency[i].point)*100
        //                 }
        //                 let improveScore=0
        //                 //console.log('improves_frequency[i]',improves_frequency[i])
        //                 if(improves_frequency[i]&&improves_frequency[i].selected[j]){
        //                  improveScore=(improves_frequency[i].selected[j]/skill_frequency[i].point)*100
        //                 // console.log("improveScore",improveScore)
        //                 }
        //                 attributes[i].push({
        //                     label: j,
        //                     excelsScore: Math.round(excelsScore).toFixed(),
        //                     couldFurtherImproveScore: Math.round(improveScore).toFixed(),
        //                   })
        //             }
        //         }
        //         if(skill_frequency[i]&&skill_frequency[i].tags){
        //             skill_frequency[i].tags=_.orderBy(skill_frequency[i].tags,[function (o) {return o.scorePercentage;},],["desc"])
        //         }
        //         if(improves_frequency[i]&&improves_frequency[i].tags){
        //             improves_frequency[i].tags=_.orderBy(improves_frequency[i].tags,[function (o) {return o.scorePercentage;},],["desc"])
        //         }
             
        //         let _data1:any={
        //             name: i,
        //             id: i.toLowerCase(),
        //             improve:bar_width_deficiency,
        //             excel:bar_width,
        //             excelsAt:{
        //                 solid: bar_width,
        //                 gradientFill: 100-bar_width,
        //                 relative_skill_proficiency_score:relative_skill_proficiency_score.toFixed(1),
        //                 members:skill_frequency[i] ?skill_frequency[i].tags:[],
        //             },
        //             couldFurtherImprove: {
        //                 solid: bar_width_deficiency,
        //                 gradientFill: 100-bar_width_deficiency,
        //                 relative_skill_deficiency_score:relative_skill_deficiency_score.toFixed(1),
        //                 members: improves_frequency[i]?improves_frequency[i].tags:[],
                      
        //                 },
        //             }
        //             skillProficiencyAndDeficiency.push(_data1)
        //             skillData.push({type:i})
        //         }
               
        //         skillProficiencyAndDeficiency=_.orderBy(skillProficiencyAndDeficiency,[function (o) {return o.name;},],["asc"])
        //         state.statusTeam=true
        //         commit('setskillProficiencyAndDeficiency',skillProficiencyAndDeficiency)
        //         commit('setskillProficiencyAndDeficiencyByteam',skillProficiencyAndDeficiency)
        //         commit('setAttributes',attributes)
        //         commit('setdatachart',data)
        //         state.loading=false

        //     }else{
        //         const datateam:any=[]
        //         const datateamImproves:any=[]
        //         const data:any=[]
        //         const teams = (await firebase.database().ref('team').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
        //         const allUser = rootState.main.allUser
        //         const team=state.organization1level[state.teamHeight]
        //         let skillProficiencyAndDeficiency:Array<any>=[]
        //         let skillData:Array<any>=[]
        //         const datenow = format(new Date(), 'YYYY-MM-DD');
        //         firebase.firestore().collection('peerfeedback_monthly_team').where('company_id','==',rootState.authen.user.company).get().then((querySnapshot)=>{
        //             querySnapshot.forEach((doc) => {
        //             const data=doc.data()
        //             // console.log("data",data)
    
        //             if(data.excels){
        //                 if(!datateam[data.team_id]){
        //                     datateam[data.team_id]={total:0}
        //                 }
                        
        //                 for(const i in data.excels){
        //                     const excel=data.excels[i]
        //                     if(!datateam[data.team_id][excel.name]){
        //                         datateam[data.team_id][excel.name]={point:0,attributes_selected:0,sum_ratings:0,tags:[],selected:{}}
        //                     }
        //                     datateam[data.team_id][excel.name].point=datateam[data.team_id][excel.name].point+excel.point
                            
        //                     if(data.excels[i].selected){
        //                         for(const j in data.excels[i].selected){
        //                             datateam[data.team_id][excel.name].attributes_selected= datateam[data.team_id][excel.name].attributes_selected+data.excels[i].selected[j].point
        //                             if(!datateam[data.team_id][excel.name]['selected'][data.excels[i].selected[j].text_en]){
        //                                 datateam[data.team_id][excel.name]['selected'][data.excels[i].selected[j].text_en]=0
        //                             }
        //                             datateam[data.team_id][excel.name]['selected'][data.excels[i].selected[j].text_en]=datateam[data.team_id][excel.name]['selected'][data.excels[i].selected[j].text_en]+data.excels[i].selected[j].point
        //                         } 
        //                     }
        //                     if(data.excels[i].suggest){
                                
        //                         for(const k in data.excels[i].suggest){
        //                             for(const l in masterSuggest){
        //                                 if(data.excels[i].suggest[k][l]){
        //                                     // console.log("masterSuggest[l]",masterSuggest[l])
        //                                     // console.log("data.excels[i].suggest[k][l]",data.excels[i].suggest[k][l])
        //                                     // console.log("total",data.excels[i].suggest[k][l]*masterSuggest[l])
        //                                     datateam[data.team_id][excel.name].sum_ratings=datateam[data.team_id][excel.name].sum_ratings+(data.excels[i].suggest[k][l]*masterSuggest[l])
        //                                 }
                                        
        //                             }
    
                                    
        //                         }
        //                     }
        //                     if(data.excels[i].send_to){
        //                         for(const j in data.excels[i].send_to){
        //                             const emailKey= data.excels[i].send_to[j].email_to.replace(/\./g, "||");
        //                             const findexcel=_.find(datateam[data.team_id][excel.name].tags, function(o) { return o.id == emailKey; });
                                
        //                             if(!findexcel&&allUser[emailKey]){
        //                                 datateam[data.team_id][excel.name].tags.push({
        //                                         name: allUser[emailKey].firstname+" "+allUser[emailKey].lastname,
        //                                         id: emailKey,
        //                                         teamname:teams[allUser[emailKey].team].name,
        //                                         imageProfile:allUser[emailKey].profilepic,
        //                                         total:1,
        //                                         score:data.excels[i].send_to[j].attribute
        //                                 })
        //                             }else{
        //                                 if(datateam[data.team_id][excel.name].tags.length>0){
        //                                     const objIndex = datateam[data.team_id][excel.name].tags.findIndex((obj => obj.id == emailKey))
        //                                     datateam[data.team_id][excel.name].tags[objIndex].score=datateam[data.team_id][excel.name].tags[objIndex].score+data.excels[i].send_to[j].attribute
        //                                     datateam[data.team_id][excel.name].tags[objIndex].total++
        //                                 }
                                       
        //                             }
                                   
        //                         }
                                
        //                     }
                         
        //                 }
                       
        //             }
    
        //             datateam[data.team_id].total+=data.total
        //             if(data.improves){
        //                 if(!datateamImproves[data.team_id]){
        //                     datateamImproves[data.team_id]={total:0}
        //                 }
        //                 for(const i in data.improves){
        //                     const improves=data.improves[i]
               
        //                     if(!datateamImproves[data.team_id][improves.name]){
        //                         datateamImproves[data.team_id][improves.name]={point:0,attributes_selected:0,tags:[],selected:{}}
        //                     }
                            
        //                     datateamImproves[data.team_id][improves.name].point++
                            
        //                     if(data.improves[i].selected){
                                
        //                         for(const j in data.improves[i].selected){
        //                             datateamImproves[data.team_id][improves.name].attributes_selected= datateamImproves[data.team_id][improves.name].attributes_selected+data.improves[i].selected[j].point
        //                             if(! datateamImproves[data.team_id][improves.name][data.improves[i].selected[j].text_en]){
        //                                 datateamImproves[data.team_id][improves.name]['selected'][data.improves[i].selected[j].text_en]=0
        //                             }
        //                             datateamImproves[data.team_id][improves.name]['selected'][data.improves[i].selected[j].text_en]=datateamImproves[data.team_id][improves.name]['selected'][data.improves[i].selected[j].text_en]+data.improves[i].selected[j].point
        //                         } 
                                
    
    
        //                     }
        //                     if(data.improves[i].send_to){
        //                         for(const j in data.improves[i].send_to){
        //                             const emailKey= data.improves[i].send_to[j].email_to.replace(/\./g, "||");
        //                             const findImproves=_.find(datateamImproves[data.team_id][improves.name].tags, function(o) { return o.id == emailKey; });
                                    
        //                             if(!findImproves && allUser[emailKey]){
        //                                 datateamImproves[data.team_id][improves.name].tags.push({
        //                                         name: allUser[emailKey].firstname+" "+allUser[emailKey].lastname,
        //                                         id: emailKey,
        //                                         teamname:teams[allUser[emailKey].team].name,
        //                                         imageProfile:allUser[emailKey].profilepic,
        //                                         scorePercentage: 0,
        //                                         total:1,
        //                                         score:data.improves[i].send_to[j].attribute
        //                                 })
        //                             }else{
        //                                 if(datateamImproves[data.team_id][improves.name].tags.length>0){
        //                                     const objIndex = datateamImproves[data.team_id][improves.name].tags.findIndex((obj => obj.id == emailKey))
        //                                     datateamImproves[data.team_id][improves.name].tags[objIndex].score=datateamImproves[data.team_id][improves.name].tags[objIndex].score+data.improves[i].send_to[j].attribute
        //                                     datateamImproves[data.team_id][improves.name].tags[objIndex].total++
        //                                 }
        //                             }
        //                         }
                                
        //                     }
                          
                            
        //                 }
                        
        //             }
     
        //             })
        //             //TodayFeedback
        //              firebase.firestore().collection('peerfeedback').where('company','==',rootState.authen.user.company).where('date','>=',datenow).get().then(async (querySnapshot)=>{
        //                 querySnapshot.forEach((doc) => {
        //                 const data=doc.data()
        //                 let emailKey = data.email_to.replace(/\./g, "||");
        //                     if(data.newversion==true&&allUser[emailKey]){
        //                         if(data.excels){
        //                             if(!datateam[allUser[emailKey].team]){
        //                                 datateam[allUser[emailKey].team]={total:0}
        //                             }
                                    
        //                             for(const i in data.excels){
        //                                 const excel=data.excels[i]
        //                                 if(!datateam[allUser[emailKey].team][excel.name]){
                                      
        //                                     datateam[allUser[emailKey].team][excel.name]={point:0,attributes_selected:0,sum_ratings:0,tags:[],selected:{}}
                                     
        //                                 }
        //                                 datateam[allUser[emailKey].team][excel.name].point++
                                        
        //                                 if(data.excels[i].selected){
        //                                     datateam[allUser[emailKey].team][excel.name].attributes_selected= datateam[allUser[emailKey].team][excel.name].attributes_selected+data.excels[i].selected.length
        //                                     for(const j in data.excels[i].selected){
                                             
        //                                         if(!datateam[allUser[emailKey].team][excel.name]['selected'][data.excels[i].selected[j].text_en]){
        //                                             datateam[allUser[emailKey].team][excel.name]['selected'][data.excels[i].selected[j].text_en]=0
        //                                         }
        //                                         datateam[allUser[emailKey].team][excel.name]['selected'][data.excels[i].selected[j].text_en]=datateam[allUser[emailKey].team][excel.name]['selected'][data.excels[i].selected[j].text_en]+1
        //                                     } 
        //                                 }
        //                                 if(data.suggest){
                                    
        //                                     datateam[allUser[emailKey].team][excel.name].sum_ratings=datateam[allUser[emailKey].team][excel.name].sum_ratings+masterSuggest[data.suggest.line1_en]
                                            
                
        //                                 }
        //                                 const _emailKey= data.email_to.replace(/\./g, "||");
        //                                 const findexcel=_.find(datateam[allUser[emailKey].team][excel.name].tags, function(o) { return o.id == _emailKey; });
        //                                 if(!findexcel){
        //                                     datateam[allUser[emailKey].team][excel.name].tags.push({
        //                                         name: allUser[_emailKey].firstname+" "+allUser[_emailKey].lastname,
        //                                         id: _emailKey,
        //                                         teamname:teams[allUser[_emailKey].team].name,
        //                                         imageProfile:allUser[_emailKey].profilepic,
        //                                         scorePercentage: 0,
        //                                         total:1,
        //                                         score:data.excels[i].selected.length
        //                                     })
        //                                 }else{
        //                                     if(datateam[allUser[emailKey].team][excel.name].tags.length>0){
        //                                         const objIndex = datateam[allUser[emailKey].team][excel.name].tags.findIndex((obj => obj.id == emailKey))
        //                                         datateam[allUser[emailKey].team][excel.name].tags[objIndex].score=datateam[allUser[emailKey].team][excel.name].tags[objIndex].score+data.excels[i].selected.length
        //                                         datateam[allUser[emailKey].team][excel.name].tags[objIndex].total++
        //                                     }
                                           
        //                                 }
                                        
        
        //                             }
                                   
        //                         }
        //                         datateam[allUser[emailKey].team].total++
        //                         if(data.improves){
        //                             if(!datateamImproves[allUser[emailKey].team]){
        //                                 datateamImproves[allUser[emailKey].team]={total:0}
        //                             }
        //                             for(const i in data.improves){
        //                                 const improves=data.improves[i]
                           
        //                                 if(!datateamImproves[allUser[emailKey].team][improves.name]){
        //                                     datateamImproves[allUser[emailKey].team][improves.name]={point:0,attributes_selected:0,tags:[]}
        //                                 }
                                        
        //                                 datateamImproves[allUser[emailKey].team][improves.name].point++
        //                                 if(data.improves[i].selected){
        
        //                                     datateamImproves[allUser[emailKey].team][improves.name].attributes_selected= datateamImproves[allUser[emailKey].team][improves.name].attributes_selected+data.improves[i].selected.length
        //                                 }
        //                                 const _emailKey= data.email_to.replace(/\./g, "||");
        //                                 const findimproves=_.find(datateamImproves[allUser[emailKey].team][improves.name].tags, function(o) { return o.id == _emailKey; });
        //                                 if(!findimproves){
        //                                 datateamImproves[allUser[emailKey].team][improves.name].tags.push({
        //                                     name: allUser[_emailKey].firstname+" "+allUser[_emailKey].lastname,
        //                                     id: _emailKey,
        //                                     teamname:teams[allUser[_emailKey].team].name,
        //                                     imageProfile:allUser[_emailKey].profilepic,
        //                                     scorePercentage: 0,
        //                                     total:1,
        //                                     score:data.improves[i].selected.length
        //                                     })
        //                                 }else{
        //                                     if(datateamImproves[allUser[emailKey].team][improves.name].tags.length>0){
        //                                         const objIndex = datateamImproves[allUser[emailKey].team][improves.name].tags.findIndex((obj => obj.id == emailKey))
        //                                         datateamImproves[allUser[emailKey].team][improves.name].tags[objIndex].score=datateamImproves[allUser[emailKey].team][improves.name].tags[objIndex].score+data.improves[i].selected.length
        //                                         datateamImproves[allUser[emailKey].team][improves.name].tags[objIndex].total++
        //                                     }
        //                                 }
        //                             }
                                    
                                    
        //                         }
        //                         datateamImproves[allUser[emailKey].team].total++
        //                     }
        //                 })
                   
              
        //                 let total_feedback=0
        //                 let total_improves=0
        //                 const improves_frequency={}
        //                 const skill_frequency={}
        //                 const average_proficiency_rating={}
        //                 const average_deficiency_rating={}
        //                 const _sum_ratings={}
        //                 const median_proficiency_rating:any=[]
        //                 const median_deficiency_rating:any=[]
        //                 for(const i in team){
        //                     if(datateam[i]){
               
        //                         for(const j in datateam[i]){
                   
        //                             if(j!="total"){
        //                                 if(!skill_frequency[j]){
        //                                     skill_frequency[j]={point:0,attributes_selected:0,sum_ratings:0,tags:[],selected:{}}
        //                                 }
        //                                 skill_frequency[j].point=skill_frequency[j].point+datateam[i][j].point
        //                                 skill_frequency[j].attributes_selected=skill_frequency[j].attributes_selected+datateam[i][j].attributes_selected
        //                                 skill_frequency[j].sum_ratings=skill_frequency[j].sum_ratings+datateam[i][j].sum_ratings
        //                             }else{
        //                                 total_feedback=total_feedback+datateam[i].total
        //                             }
        //                             if(datateam[i][j].selected){
        //                                 for(const k in datateam[i][j].selected){
        //                                     if(!skill_frequency[j]['selected'][k]){
        //                                         skill_frequency[j]['selected'][k]=0
        //                                     }
        //                                     skill_frequency[j]['selected'][k]=skill_frequency[j]['selected'][k]+datateam[i][j].selected[k]
                                            
        //                                 }
        //                             }
        //                             if(datateam[i][j].tags){
        //                                 for(const tagId in datateam[i][j].tags){
        //                                     datateam[i][j].tags[tagId].scorePercentage=(datateam[i][j].tags[tagId].score)/(datateam[i][j].tags[tagId].total*6)*100
        //                                 }
        //                                 skill_frequency[j]['tags'].push(...datateam[i][j].tags)
        //                             }
                            
                                    
        //                         }
        //                     }
        //                     if(datateamImproves[i]){
        //                         for(const j in datateamImproves[i]){
        //                             if(j!="total"){
        //                                 if(!improves_frequency[j]){
        //                                     improves_frequency[j]={point:0,attributes_selected:0,tags:[],selected:{}}
        //                                 }
        //                                 improves_frequency[j].point=improves_frequency[j].point+datateamImproves[i][j].point
        //                                 improves_frequency[j].attributes_selected=improves_frequency[j].attributes_selected+datateamImproves[i][j].attributes_selected
        //                             }
        //                             if(datateamImproves[i][j].tags){
                                      
        //                                 for(const tagId in datateamImproves[i][j].tags){
                                        
        //                                     datateamImproves[i][j].tags[tagId].scorePercentage=(datateamImproves[i][j].tags[tagId].score)/(datateamImproves[i][j].tags[tagId].total*6)*100
        //                                 }
        //                                 improves_frequency[j]['tags'].push(...datateamImproves[i][j].tags)
        //                             }
                                   
        //                             if(datateamImproves[i][j].selected){
        //                                 for(const k in datateamImproves[i][j].selected){
        //                                     if(!improves_frequency[j]['selected'][k]){
        //                                         improves_frequency[j]['selected'][k]=0
        //                                     }
        //                                     improves_frequency[j]['selected'][k]=improves_frequency[j]['selected'][k]+datateamImproves[i][j].selected[k]
                                            
        //                                 }
        //                             }
                                    
        //                         }
        //                     }
                         
        //                 }
        //                 for(const i in skill_frequency){
        //                     if(!average_proficiency_rating[i]){
        //                         average_proficiency_rating[i]={name:i,size:0,rating:0,impact_on_performance:0,type:'excel'}
        //                     }
        //                     average_proficiency_rating[i]['impact_on_performance'] = skill_frequency[i].sum_ratings / skill_frequency[i].point
        //                     average_proficiency_rating[i]['size'] = skill_frequency[i].attributes_selected / skill_frequency[i].point
        //                     average_proficiency_rating[i]['rating']=(skill_frequency[i].point/total_feedback)*100
        //                     median_proficiency_rating.push(average_proficiency_rating[i]['rating'])
                        
        //                 }
        //                 if(median_proficiency_rating.length>0){
        //                 await dispatch('median',{rating:median_proficiency_rating,type:"median_excel"})
        //                 }
                      
                        
        //                 for(const i in improves_frequency){
        //                     if(!average_deficiency_rating[i]){
        //                         average_deficiency_rating[i]={name:i,size:0,rating:0,impact_on_performance:0}
        //                     }
        //                     if(skill_frequency[i]){
        //                         average_deficiency_rating[i]['impact_on_performance'] = skill_frequency[i].sum_ratings / skill_frequency[i].point
        //                     }
        //                     average_deficiency_rating[i]['size']=improves_frequency[i].attributes_selected / improves_frequency[i].point
        //                     average_deficiency_rating[i]['rating']=(improves_frequency[i].point/total_feedback)*100
        //                     // avg_selected_attributes[i]=total_attributes_selected / improves_frequency[i]
        //                     // data.push({name:i,size:average_deficiency_rating[i]['size'],x:((average_deficiency_rating[i]['rating']*100/top_1[0]['rating'])*-1),y:average_deficiency_rating[i]['impact_on_performance'],type:'improves'})
                            
        //                     median_deficiency_rating.push(average_deficiency_rating[i]['rating'])
        //                 }
        //                 const sortData1 = _.orderBy(average_deficiency_rating, [
        //                     'rating'
        //                   ], ['desc']);
        //      //             console.log("sortData1",sortData1)
        //                  const top_1 = _.slice(sortData1, 0, 1)
        //                 //  console.log("top_1",top_1)
        //                  for(const i in improves_frequency){
        //                     // console.log("average_deficiency_rating[i]['rating']",i,average_deficiency_rating[i]['rating'])
        //                     data.push({name:i,size:average_deficiency_rating[i]['size'],x:((average_deficiency_rating[i]['rating']*100/top_1[0]['rating'])*-1),y:average_deficiency_rating[i]['impact_on_performance'],type:'improves'})
        //                  }
        //                 if(median_deficiency_rating.length>0){
        //                     await dispatch('median',{rating:median_deficiency_rating,type:"median_improves"})
        //                 }
        //                 const attributes:any={}
        //                 const sortData = _.orderBy(average_proficiency_rating, [
        //                     'rating'
        //                   ], ['desc']);
        //                 //   console.log("sortData",sortData)
        //                  const top1 = _.slice(sortData, 0, 1)
        //                 //  console.log("top1",top1)
        //                 for(const i in skill_frequency){
        //                 let members:Array<any>=[]
        //                 const max_proficiency_rating= _.orderBy(average_proficiency_rating,[function (o) {return o.rating;},],["desc"])[0];
        //                 const skill_proficiency_rating=average_proficiency_rating[i]['rating']
        //                 const relative_skill_proficiency_score = skill_proficiency_rating / state.median_excel
        //                 const bar_width = ( skill_proficiency_rating/ max_proficiency_rating.rating) * 100
                        
                        
        //                 data.push({name:i,size:average_proficiency_rating[i]['size'],x:(average_proficiency_rating[i]['rating']*100/top1[0]['rating']),y:average_proficiency_rating[i]['impact_on_performance'],type:'excel',bar_width_excel:bar_width,relative_skill_proficiency_score:relative_skill_proficiency_score})
                        
        //                 const max_deficiency_rating= _.orderBy(average_deficiency_rating,[function (o) {return o.rating;},],["desc"])[0];
        //                 let relative_skill_deficiency_score=0
        //                 let bar_width_deficiency=0
        //                 if(average_deficiency_rating[i]){
        //                     relative_skill_deficiency_score = average_deficiency_rating[i]['rating'] / state.median_improves
        //                     bar_width_deficiency = ( average_deficiency_rating[i]['rating']/ max_deficiency_rating.rating) * 100
        //                 }
                        
        //                 if(skill_frequency[i].selected){
        //                     for(const j in skill_frequency[i].selected){
                                
        //                         if(!attributes[i]){
        //                             attributes[i]=[]
        //                         }
        //                         let excelsScore=0
        //                         if(skill_frequency[i].selected[j]){
        //                          excelsScore=(skill_frequency[i].selected[j]/skill_frequency[i].point)*100
        //                         }
        //                         let improveScore=0
                           
        //                         if(improves_frequency[i]&&improves_frequency[i].selected[j]){
        //                          improveScore=(improves_frequency[i].selected[j]/skill_frequency[i].point)*100
                                 
        //                         }
        //                         attributes[i].push({
        //                             label: j,
        //                             excelsScore: Math.round(excelsScore).toFixed(),
        //                             couldFurtherImproveScore: Math.round(improveScore).toFixed(),
        //                           })
        //                     }
        //                 }
        //                 if(skill_frequency[i]&&skill_frequency[i].tags){
        //                     skill_frequency[i].tags=_.orderBy(skill_frequency[i].tags,[function (o) {return o.scorePercentage;},],["desc"])
        //                 }
        //                 if(improves_frequency[i]&&improves_frequency[i].tags){
        //                     improves_frequency[i].tags=_.orderBy(improves_frequency[i].tags,[function (o) {return o.scorePercentage;},],["desc"])
        //                 }
        //                 let _data1:any={
        //                     name: i,
        //                     id: i.toLowerCase(),
        //                     improve:bar_width_deficiency,
        //                     excel:bar_width,
        //                     excelsAt:{
        //                         solid: bar_width,
        //                         gradientFill: 100-bar_width,
        //                         relative_skill_proficiency_score:relative_skill_proficiency_score.toFixed(1),
        //                         members: skill_frequency[i].tags,
        //                     },
        //                     couldFurtherImprove: {
        //                         solid: bar_width_deficiency,
        //                         gradientFill: 100-bar_width_deficiency,
        //                         relative_skill_deficiency_score:relative_skill_deficiency_score.toFixed(1),
        //                         members: improves_frequency[i]?improves_frequency[i].tags:[],
                              
        //                         },
        //                     }
        //                     skillProficiencyAndDeficiency.push(_data1)
        //                     skillData.push({type:i})
        //                 }
                       
                       
        //                 skillProficiencyAndDeficiency=_.orderBy(skillProficiencyAndDeficiency,[function (o) {return o.name;},],["asc"])
        //                 commit('setskillProficiencyAndDeficiency',skillProficiencyAndDeficiency)
        //                 skillData=_.orderBy(skillData,[function (o) {return o.type;},],["asc"])
        //                 commit('setSkill',skillData)
        //                 commit('setskillProficiencyAndDeficiencyAll',skillProficiencyAndDeficiency)
        //                 commit('setAttributes',attributes)
        //                 commit('setdatachart',data)
        //                 commit('setdataAll',{excel:datateam,improves:datateamImproves})
        //                 state.loading=false
        //                 // console.log('average_proficiency_rating',average_proficiency_rating)
        //                 // console.log('average_deficiency_rating',average_deficiency_rating)
                        
        //             })
    
        //         })

        //     }
           
     
           
        // },
        
        median({ commit, state,rootState,dispatch }: any,value:any) {
            const values:any=value.rating
            const type:any=value.type
            //console.log('values',values )
            if(values.length ===0) throw new Error("No inputs");

            values.sort(function(a,b){
              return a-b;
            });
          
            var half = Math.floor(values.length / 2);
            
            if (values.length % 2){
                state[type]=values[half];
                return values[half];
            }            
            state[type]=(values[half - 1] + values[half]) / 2.0;
            return (values[half - 1] + values[half]) / 2.0;
        },
        filtersData({ commit, state,rootState,dispatch }: any,value:any) {
            let results: Array<any> = [];
            if(state.statusTeam==true){
              results = state.skillProficiencyAndDeficiencyByteam
            }else{
              results = state.skillProficiencyAndDeficiencyAll
            }
            let skill:Array<any>=[]

            if(value.length>0){
               
                value.map((item:any)=>{
                    const _skill=_.find(results, function (s) { 
                        return s.name==item
                    });
                    skill.push(_skill)
                })
            }else{
                skill=results
            }
            commit('setskillProficiencyAndDeficiency',skill)
          
        },
        sortData({ commit, state,rootState,dispatch }: any,type:any) {
            let skillProficiencyAndDeficiency=state.skillProficiencyAndDeficiency
      
            if(type=='Proficiency'){
              
                skillProficiencyAndDeficiency=_.orderBy(skillProficiencyAndDeficiency,[function (o) {return o.excel;},],["desc"])
            }else{
                skillProficiencyAndDeficiency=_.orderBy(skillProficiencyAndDeficiency,[function (o) {return o.improve;},],["desc"])
            }
            
            commit('setskillProficiencyAndDeficiency',skillProficiencyAndDeficiency)
        },
        async changeTime({ commit, state,rootState,dispatch }: any,value:any) {
            let userData={}
            state.changeTime=true
            const teams = await getTeamByCompany(rootState.authen.user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
            const company = await getCompany(rootState.authen.user.company)
            const chart={"Truly":0,
            "Exceeding":0,
            "Meets":0,
            "Needs":0,}
            const masterSuggest={
                "Truly":4,
                "Exceeding":3,
                "Meets":2,
                "Needs":1,
            }
            const datateam={}//state.dataAll.excel
            const datateamImproves={}//state.dataAll.improves
            const allUser = rootState.main.allUser
            const team=state.organization1level[state.teamHeight]
            let date=''
            let past_date= ''
            if(value=='Past 6-months'){
                 date = format(addMonths(new Date(),-5), 'YYYY-MM');
                 past_date = format(addMonths(new Date(),-11), 'YYYY-MM');

            }else if(value=='Past 3-months'){
                date = format(addMonths(new Date(),-2), 'YYYY-MM');
                 past_date = format(addMonths(new Date(),-5), 'YYYY-MM');
                 

            }else if(value=='Past year'){
                date = format(addMonths(new Date(),-12), 'YYYY-MM');
                 past_date = format(addMonths(new Date(),-24), 'YYYY-MM');

            }
           
            for(const i in state.dataAllArr){
                const data=state.dataAllArr[i]
                if(!datateam[data.team_id]){
                    datateam[data.team_id]={total:0}
                }
                if(!datateamImproves[data.team_id]){
                    datateamImproves[data.team_id]={total:0}
                }
                if(format(data.months,'YYYY-MM-DD')>=date){
                  
                    if(data.excels){
                        
                        let statuscal=true
                        for(const i in data.excels){
                            const excel=data.excels[i]
                            if(!datateam[data.team_id][excel.name]){
                                datateam[data.team_id][excel.name]={point:0,attributes_selected:0,sum_ratings:0,tags:[],selected:{},pastpoint:0}
                            }
                            datateam[data.team_id][excel.name].point=datateam[data.team_id][excel.name].point+excel.point
                            
                            if(data.excels[i].selected){
                                for(const j in data.excels[i].selected){
                                    datateam[data.team_id][excel.name].attributes_selected= datateam[data.team_id][excel.name].attributes_selected+data.excels[i].selected[j].point
                                    if(!datateam[data.team_id][excel.name]['selected'][data.excels[i].selected[j].text_en]){
                                        datateam[data.team_id][excel.name]['selected'][data.excels[i].selected[j].text_en]=0
                                    }
                                    datateam[data.team_id][excel.name]['selected'][data.excels[i].selected[j].text_en]=datateam[data.team_id][excel.name]['selected'][data.excels[i].selected[j].text_en]+data.excels[i].selected[j].point
                                } 
                            }
                            if(data.excels[i].suggest){
                                
                                for(const k in data.excels[i].suggest){
                                    for(const l in masterSuggest){
                                        if(data.excels[i].suggest[k][l]){
                                            // console.log("data.excels[i].suggest[k][l]",data.excels[i].suggest[k][l])
                                            // console.log("data.excels[i].suggest[k][l]",data.excels[i].suggest[k][l])
                                            // console.log("total",data.excels[i].suggest[k][l]*masterSuggest[l])
                                            datateam[data.team_id][excel.name].sum_ratings=datateam[data.team_id][excel.name].sum_ratings+(data.excels[i].suggest[k][l]*masterSuggest[l])
                                        }
                                        
                                    }
    
                                    
                                }
                            }
                            if(data.excels[i].send_to){
                                for(const j in data.excels[i].send_to){
                                    
                                    const emailKey= data.excels[i].send_to[j].email_to.replace(/\./g, "||");
                                    const findexcel=_.find(datateam[data.team_id][excel.name].tags, function(o) { return o.id == emailKey; });
                                    
                                    if(data.excels[i].send_to[j].suggest){
                                        chart[data.excels[i].send_to[j].suggest]++
                                    }
                                    
                                    if(!userData[emailKey]){
                                        if(allUser[emailKey]){
                                            userData[emailKey]={
                                                company:company.name,
                                                ratingAll:0,
                                                ratingavg:0,
                                                total:0,
                                                interaction:0,
                                                ratingavg_sort:0,
                                                emailKey:emailKey,
                                                team:allUser[emailKey].team,
                                                teamname:teams[allUser[emailKey].team].name,
                                                firstname:allUser[emailKey].firstname,
                                                lastname:allUser[emailKey].lastname,
                                                profilepic:allUser[emailKey].profilepic,
                                                initial:(allUser[emailKey].firstname?allUser[emailKey].firstname.slice(0, 1):'')+(allUser[emailKey].lastname?allUser[emailKey].lastname.slice(0, 1):''),
                                                suggest:[],//data.excels[i].send_to[j]&&data.excels[i].send_to[j].suggest?data.excels[i].send_to[j].suggest:''
                                            }
                                        }
                                        
                                    }
                                    // if(allUser[emailKey]){
                                        
                                    //     userData[emailKey].ratingAll=userData[emailKey].ratingAll+(masterSuggest[data.excels[i].send_to[j].suggest]?masterSuggest[data.excels[i].send_to[j].suggest]:0)
                                    //     userData[emailKey].total++
                                    //     // const filterData=_.filter(data.send_to, function(o) { return o == allUser[emailKey].email; });
                                    //     //     if(filterData.length>0&&statuscal==true){
                                    //     //     statuscal=false
                                    //     //     userData[emailKey].interaction=userData[emailKey].interaction+filterData.length
                                    //     //     }
                                    // }
                                    
    
                                    if(!findexcel&&allUser[emailKey]){
                                        datateam[data.team_id][excel.name].tags.push({
                                                name: allUser[emailKey].firstname+" "+allUser[emailKey].lastname,
                                                id: emailKey,
                                                teamname:teams[allUser[emailKey].team].name,
                                                imageProfile:allUser[emailKey].profilepic,
                                                total:1,
                                                score:data.excels[i].send_to[j].attribute,
                                                
                                        })
                                    }else{
                                        if(datateam[data.team_id][excel.name].tags.length>0){
                                            const objIndex = datateam[data.team_id][excel.name].tags.findIndex((obj => obj.id == emailKey))
                                            if(objIndex>-1){
                                            datateam[data.team_id][excel.name].tags[objIndex].score=datateam[data.team_id][excel.name].tags[objIndex].score+data.excels[i].send_to[j].attribute
                                            datateam[data.team_id][excel.name].tags[objIndex].total++
                                            }
                                        }
                                       
                                    }
                                   
                                }
                                
                            }
                        }
                   

                        datateam[data.team_id].total+=data.total
                    }
    
                    
                    if(data.improves){
                        
                        for(const i in data.improves){
                            const improves=data.improves[i]
               
                            if(!datateamImproves[data.team_id][improves.name]){
                                datateamImproves[data.team_id][improves.name]={point:0,attributes_selected:0,tags:[],selected:{},pastpoint:0}
                            }
                            
                            datateamImproves[data.team_id][improves.name].point++
                            
                            if(data.improves[i].selected){
                                
                                for(const j in data.improves[i].selected){
                                    datateamImproves[data.team_id][improves.name].attributes_selected= datateamImproves[data.team_id][improves.name].attributes_selected+data.improves[i].selected[j].point
                                    if(! datateamImproves[data.team_id][improves.name][data.improves[i].selected[j].text_en]){
                                        datateamImproves[data.team_id][improves.name]['selected'][data.improves[i].selected[j].text_en]=0
                                    }
                                    datateamImproves[data.team_id][improves.name]['selected'][data.improves[i].selected[j].text_en]=datateamImproves[data.team_id][improves.name]['selected'][data.improves[i].selected[j].text_en]+data.improves[i].selected[j].point
                                } 
                                
    
    
                            }
                            if(data.improves[i].send_to){
                                for(const j in data.improves[i].send_to){
                                    const emailKey= data.improves[i].send_to[j].email_to.replace(/\./g, "||");
                                    const findImproves=_.find(datateamImproves[data.team_id][improves.name].tags, function(o) { return o.id == emailKey; });
                                    
                                    if(!findImproves && allUser[emailKey]){
                                        datateamImproves[data.team_id][improves.name].tags.push({
                                                name: allUser[emailKey].firstname+" "+allUser[emailKey].lastname,
                                                id: emailKey,
                                                teamname:teams[allUser[emailKey].team].name,
                                                imageProfile:allUser[emailKey].profilepic,
                                                scorePercentage: 0,
                                                total:1,
                                                score:data.improves[i].send_to[j].attribute
                                        })
                                    }else{
                                        if(datateamImproves[data.team_id][improves.name].tags.length>0){
                                            const objIndex = datateamImproves[data.team_id][improves.name].tags.findIndex((obj => obj.id == emailKey))
                                            if(objIndex>-1){
                                            datateamImproves[data.team_id][improves.name].tags[objIndex].score=datateamImproves[data.team_id][improves.name].tags[objIndex].score+data.improves[i].send_to[j].attribute
                                            datateamImproves[data.team_id][improves.name].tags[objIndex].total++
                                            }
                                        }
                                    }
                                }
                                
                            }
                          
                            
                        }
                        
                    }

                    if(data.send_to){
                        const gruopbyData=_.groupBy(data.send_to, function (b) { return b })
                        
                        for(const i in gruopbyData){
                            const emailKey= i.replace(/\./g, "||");
                            if(userData[emailKey]){
                            userData[emailKey].interaction=userData[emailKey].interaction+gruopbyData[i].length
                            }
                        }
                    }
                    if(data.suggest){
                        for(const i in data.suggest){
                            const emailKey= data.suggest[i].email_to.replace(/\./g, "||");
                            if(allUser[emailKey]){
                                userData[emailKey].ratingAll=userData[emailKey].ratingAll+(masterSuggest[data.suggest[i].suggest]?masterSuggest[data.suggest[i].suggest]:0)
                                userData[emailKey].total++
                                userData[emailKey].suggest.push(data.suggest[i])

                            }
                            chart[data.suggest[i].suggest]++
                        }
                       
                    }
    
    
                }else if(format(data.months,'YYYY-MM-DD')>=past_date){
                    if(data.excels){
                        for(const i in data.excels){
                            const excel=data.excels[i]
                            
                            
                            if(!datateam[data.team_id][excel.name]){
                                datateam[data.team_id][excel.name]={point:0,attributes_selected:0,sum_ratings:0,tags:[],selected:{},pastpoint:0}
                            }
                            datateam[data.team_id][excel.name].pastpoint=datateam[data.team_id][excel.name].pastpoint+excel.point
                            
                        }
                       
                    }
    
                    if(data.improves){
                        
                        for(const i in data.improves){
                            const improves=data.improves[i]
               
                            if(!datateamImproves[data.team_id][improves.name]){
                                datateamImproves[data.team_id][improves.name]={point:0,attributes_selected:0,tags:[],selected:{},pastpoint:0}
                            }
                            datateamImproves[data.team_id][improves.name].pastpoint=datateamImproves[data.team_id][improves.name].pastpoint+improves.point
                            
                        }
                        
                    }
    
    
                    
                }
                
            }
            for(const u in userData){
                userData[u].ratingavg=isNaN(userData[u].ratingAll/userData[u].total)?0:(userData[u].ratingAll/userData[u].total).toFixed(1)
                userData[u].ratingavg_sort=isNaN(userData[u].ratingAll/userData[u].total)?0:(userData[u].ratingAll/userData[u].total)
            }
            let sort_data_asc=_.orderBy(userData, ['ratingavg_sort','total'], ['asc', 'asc']);
            let sort_data_desc= _.orderBy(userData, ['ratingavg_sort','total'], ['desc', 'desc']);
            let _count=0
            let count=0
            for(const j in sort_data_asc){
                _count++
                sort_data_asc[j].rank_lowest=_count
            }  
        
            for(const j in sort_data_desc){
                count++
                sort_data_desc[j].rank_highest=count
            }  
            // console.log('datateam',datateam)
            // console.log('datateamImproves',datateamImproves)
            commit('setdataAll',{excel:datateam,improves:datateamImproves})
            state.userData=userData
            dispatch('getData',state.team_id)


        },
        async getData({ commit, state,rootState,dispatch }: any,team_id:any) {
            state.loading=true
            let userData={}
            const attributes:any={}
           
            const chart={"Truly":0,
            "Exceeding":0,
            "Meets":0,
            "Needs":0,}
            const masterSuggest={
                "Truly":4,
                "Exceeding":3,
                "Meets":2,
                "Needs":1,
            }
            if(team_id){
                if(state.changetime==true){
                    state.changetime=false
                    state.rank=true
                }else{
                    state.rank=false
                }
                
                const datateam=state.dataAll.excel
                const  userDataAll=state.userData
                const datateamImproves=state.dataAll.improves
                
                const data:any=[]
                let team=state.organization1level[team_id]
                state.team_id=team_id
                if(!team){
                    team={[team_id]:true}
                }
                if(team_id=="all"){
                    state.team_id="all"
                    team=state.organization1level[state.teamHeight]
                }
                
                // let skillProficiencyAndDeficiency:Array<any>=[]
                // let skillData:Array<any>=[]
                // let total_feedback=0
                // const improves_frequency={}
                // const skill_frequency={}
                // const average_proficiency_rating={}
                // const average_deficiency_rating={}
                // const median_proficiency_rating:any=[]
                // const median_deficiency_rating:any=[]
                // const skillMaster:Array<any>=[]
                // for(const i in team){
                //     if(datateam[i]){
       
                //         for(const j in datateam[i]){
           
                //             if(j!="total"){
                //                 if(!skill_frequency[j]){
                //                     skill_frequency[j]={point:0,attributes_selected:0,sum_ratings:0,tags:[],selected:{}}
                //                 }
                //                 skill_frequency[j].point=skill_frequency[j].point+datateam[i][j].point
                //                 skill_frequency[j].attributes_selected=skill_frequency[j].attributes_selected+datateam[i][j].attributes_selected
                //                 skill_frequency[j].sum_ratings=skill_frequency[j].sum_ratings+datateam[i][j].sum_ratings
                //             }else{
                //                 total_feedback=total_feedback+datateam[i].total
                //             }
                //             if(datateam[i][j].selected){
                //                 for(const k in datateam[i][j].selected){
                //                     if(!skill_frequency[j]['selected'][k]){
                //                         skill_frequency[j]['selected'][k]=0
                //                     }
                //                     skill_frequency[j]['selected'][k]=skill_frequency[j]['selected'][k]+datateam[i][j].selected[k]
                                    
                //                 }
                //             }
                //             if(datateam[i][j].tags){
                //                 for(const tagId in datateam[i][j].tags){
                //                     datateam[i][j].tags[tagId].scorePercentage=(datateam[i][j].tags[tagId].score)/(datateam[i][j].tags[tagId].total*6)*100
                //                 }
                //                 skill_frequency[j]['tags'].push(...datateam[i][j].tags)
                //             }
                    
                            
                //         }
                //     }
                //     if(datateamImproves[i]){
                //         for(const j in datateamImproves[i]){
                //             if(j!="total"){
                //                 if(!improves_frequency[j]){
                //                     improves_frequency[j]={point:0,attributes_selected:0,tags:[],selected:{}}
                //                 }
                //                 improves_frequency[j].point=improves_frequency[j].point+datateamImproves[i][j].point
                //                 improves_frequency[j].attributes_selected=improves_frequency[j].attributes_selected+datateamImproves[i][j].attributes_selected
                //             }
                //             if(datateamImproves[i][j].tags){
                                      
                //                 for(const tagId in datateamImproves[i][j].tags){
                //                     datateamImproves[i][j].tags[tagId].scorePercentage=(datateamImproves[i][j].tags[tagId].score)/(datateamImproves[i][j].tags[tagId].total*6)*100
                //                 }
                //                 improves_frequency[j]['tags'].push(...datateamImproves[i][j].tags)
                //             }
                           
                //             if(datateamImproves[i][j].selected){
                //                 for(const k in datateamImproves[i][j].selected){
                //                     if(!improves_frequency[j]['selected'][k]){
                //                         improves_frequency[j]['selected'][k]=0
                //                     }
                //                     improves_frequency[j]['selected'][k]=improves_frequency[j]['selected'][k]+datateamImproves[i][j].selected[k]
                                    
                //                 }
                //             }
                            
                //         }
                //     }
                 
                // }
               
                // for(const i in skill_frequency){
                //     if(!average_proficiency_rating[i]){
                //         average_proficiency_rating[i]={name:i,size:0,rating:0,impact_on_performance:0,type:'excel'}
                //     }
                //     average_proficiency_rating[i]['impact_on_performance'] = skill_frequency[i].sum_ratings / skill_frequency[i].point
                //     average_proficiency_rating[i]['size'] = skill_frequency[i].attributes_selected / skill_frequency[i].point
                //     average_proficiency_rating[i]['rating']=(skill_frequency[i].point/total_feedback)*100
                //     median_proficiency_rating.push(average_proficiency_rating[i]['rating'])
                //     const skillfind=_.find(skillMaster,function(o) { return o == i; });
                //     if(!skillfind){
                //         skillMaster.push(i)
                //     }
                   
                
                // }
                // if(median_proficiency_rating.length>0){
                // await dispatch('median',{rating:median_proficiency_rating,type:"median_excel"})
                // }
                
                // for(const i in improves_frequency){
                //     if(!average_deficiency_rating[i]){
                //         average_deficiency_rating[i]={name:i,size:0,rating:0,impact_on_performance:0}
                //     }
                    
                //     average_deficiency_rating[i]['impact_on_performance'] = skill_frequency[i]?skill_frequency[i].sum_ratings / skill_frequency[i].point:0
                //     average_deficiency_rating[i]['size']=improves_frequency[i].attributes_selected / improves_frequency[i].point
                //     average_deficiency_rating[i]['rating']=(improves_frequency[i].point/total_feedback)*100
                //     // avg_selected_attributes[i]=total_attributes_selected / improves_frequency[i]
                //     //data.push({name:i,size:average_deficiency_rating[i]['size'],x:average_deficiency_rating[i]['rating'],y:average_deficiency_rating[i]['impact_on_performance'],type:'improves'})
                //     median_deficiency_rating.push(average_deficiency_rating[i]['rating'])
                //     const skillfind=_.find(skillMaster,function(o) { return o == i; });
                //     if(!skillfind){
                //         skillMaster.push(i)
                //     }
                    
                // }
                // const sortData1 = _.orderBy(average_deficiency_rating, [
                //     'rating'
                //   ], ['desc']);
                //  const top_1 = _.slice(sortData1, 0, 1)
                //  for(const i in improves_frequency){
                //     // console.log("average_deficiency_rating[i]['rating']",i,average_deficiency_rating[i]['rating'])
                //     data.push({name:i,size:average_deficiency_rating[i]['size'],x:((average_deficiency_rating[i]['rating']*100/top_1[0]['rating'])*-1),y:average_deficiency_rating[i]['impact_on_performance'],type:'improves'})
                //  }
                // if(median_deficiency_rating.length>0){
                //     await dispatch('median',{rating:median_deficiency_rating,type:"median_improves"})
                // }
                // const attributes:any={}
                // const sortData = _.orderBy(average_proficiency_rating, [
                //     'rating'
                //   ], ['desc']);
                //  const top1 = _.slice(sortData, 0, 1)
                // for(const id in skillMaster){
                // const i= skillMaster[id]  
                // let members:Array<any>=[]
                // let relative_skill_proficiency_score=0
                // let bar_width=0
                // if(average_proficiency_rating[i]){

                //     const max_proficiency_rating= _.orderBy(average_proficiency_rating,[function (o) {return o.rating;},],["desc"])[0];
                //     const skill_proficiency_rating=average_proficiency_rating[i]?average_proficiency_rating[i]['rating']:0
                //     relative_skill_proficiency_score = skill_proficiency_rating / state.median_excel
                //     bar_width = ( skill_proficiency_rating/ max_proficiency_rating.rating) * 100
                //     data.push({name:i,size:average_proficiency_rating[i]['size'],x:(average_proficiency_rating[i]['rating']*100/top1[0]['rating']),y:average_proficiency_rating[i]['impact_on_performance'],type:'excel',bar_width_excel:bar_width,relative_skill_proficiency_score:relative_skill_proficiency_score})
                //     // data.push({name:i,size:average_proficiency_rating[i]['size'],x:average_proficiency_rating[i]['rating'],y:average_proficiency_rating[i]['impact_on_performance'],type:'excel',bar_width_excel:bar_width,relative_skill_proficiency_score:relative_skill_proficiency_score})
                    
                // }
           
                // const max_deficiency_rating= _.orderBy(average_deficiency_rating,[function (o) {return o.rating;},],["desc"])[0];
                // let relative_skill_deficiency_score=0
                // let bar_width_deficiency=0
                // if(average_deficiency_rating[i]){
                //     relative_skill_deficiency_score = average_deficiency_rating[i]['rating'] / state.median_improves
                //     bar_width_deficiency = ( average_deficiency_rating[i]['rating']/ max_deficiency_rating.rating) * 100
                // }
          
                // if(skill_frequency[i]&&skill_frequency[i].selected){
                //     for(const j in skill_frequency[i].selected){
                        
                //         if(!attributes[i]){
                //             attributes[i]=[]
                //         }
                //         let excelsScore=0
                //         if(skill_frequency[i].selected[j]){
                //          excelsScore=(skill_frequency[i].selected[j]/skill_frequency[i].point)*100
                //         }
                //         let improveScore=0
                //         //console.log('improves_frequency[i]',improves_frequency[i])
                //         if(improves_frequency[i]&&improves_frequency[i].selected[j]){
                //          improveScore=(improves_frequency[i].selected[j]/skill_frequency[i].point)*100
                //         // console.log("improveScore",improveScore)
                //         }
                //         attributes[i].push({
                //             label: j,
                //             excelsScore: Math.round(excelsScore).toFixed(),
                //             couldFurtherImproveScore: Math.round(improveScore).toFixed(),
                //           })
                //     }
                // }
                // if(skill_frequency[i]&&skill_frequency[i].tags){
                //     skill_frequency[i].tags=_.orderBy(skill_frequency[i].tags,[function (o) {return o.scorePercentage;},],["desc"])
                // }
                // if(improves_frequency[i]&&improves_frequency[i].tags){
                //     improves_frequency[i].tags=_.orderBy(improves_frequency[i].tags,[function (o) {return o.scorePercentage;},],["desc"])
                // }
             
                // let _data1:any={
                //     name: i,
                //     id: i.toLowerCase(),
                //     improve:bar_width_deficiency.toFixed(),
                //     excel:bar_width.toFixed(),
                //     compareexcel:"0",
                //     compareimprove:"+1",
                //     excelsAt:{
                //         solid: bar_width,
                //         gradientFill: 100-bar_width,
                //         relative_skill_proficiency_score:relative_skill_proficiency_score.toFixed(1),
                //         members:skill_frequency[i] ?skill_frequency[i].tags:[],
                //     },
                //     couldFurtherImprove: {
                //         solid: bar_width_deficiency,
                //         gradientFill: 100-bar_width_deficiency,
                //         relative_skill_deficiency_score:relative_skill_deficiency_score.toFixed(1),
                //         members: improves_frequency[i]?improves_frequency[i].tags:[],
                      
                //         },
                //     }
                //     skillProficiencyAndDeficiency.push(_data1)
                //     skillData.push({type:i})
                // }
                let skillProficiencyAndDeficiency:Array<any>=[]
                let skill_frequency:any={}
                let userData:any=[]
                    const skill:any=[]
                    let improves_frequency:any={}
                 
                    for(const i in team){
                        const _userdata=_.filter(userDataAll, function(o) { return o.team == i; });
                        userData.push(..._userdata)
                        
                        //excel
                        if(datateam[i]){
                            for(const j in datateam[i]){
                            if(j!="total"){
                                if(!skill_frequency[j]){
                                    skill_frequency[j]={point:0,attributes_selected:0,sum_ratings:0,tags:[],selected:{},pastpoint:0}
                                }
                                const find=_.find(skill,function(o) { return o == j; });
                                if(!find){
                                skill.push(j)}
                                skill_frequency[j].point=skill_frequency[j].point+datateam[i][j].point
                                skill_frequency[j].attributes_selected=skill_frequency[j].attributes_selected+datateam[i][j].attributes_selected
                                skill_frequency[j].sum_ratings=skill_frequency[j].sum_ratings+datateam[i][j].sum_ratings
                                skill_frequency[j].pastpoint=skill_frequency[j].pastpoint+datateam[i][j].pastpoint
                                //console.log('skill_frequency[j].pastpoint',datateam[i][j].pastpoint)
                            }else{
                                //total_feedback=total_feedback+datateam[i].total
                            }
                            if(datateam[i][j].selected){
                                for(const k in datateam[i][j].selected){
                                    if(!skill_frequency[j]['selected'][k]){
                                        skill_frequency[j]['selected'][k]=0
                                    }
                                    skill_frequency[j]['selected'][k]=skill_frequency[j]['selected'][k]+datateam[i][j].selected[k]
                                    
                                }
                            }
                            if(datateam[i][j].tags){
                                for(const tagId in datateam[i][j].tags){
                                    datateam[i][j].tags[tagId].scorePercentage=(datateam[i][j].tags[tagId].score)/(datateam[i][j].tags[tagId].total*6)*100
                                }
                                skill_frequency[j]['tags'].push(...datateam[i][j].tags)
                            }

                         }

                        }
                        //improves
                        if(datateamImproves[i]){
                            for(const j in datateamImproves[i]){
                                if(j!="total"){
                                    if(!improves_frequency[j]){
                                        improves_frequency[j]={point:0,attributes_selected:0,tags:[],selected:{},pastpoint:0}
                                    }
                                    const find=_.find(skill,function(o) { return o == j; });
                                    if(!find){
                                        skill.push(j)
                                    }
                                    
                                    improves_frequency[j].point=improves_frequency[j].point+datateamImproves[i][j].point
                                    improves_frequency[j].attributes_selected=improves_frequency[j].attributes_selected+datateamImproves[i][j].attributes_selected
                                    improves_frequency[j].pastpoint=improves_frequency[j].pastpoint+datateamImproves[i][j].pastpoint
                                }
                                
                                if(datateamImproves[i][j].tags){
                                  
                                    for(const tagId in datateamImproves[i][j].tags){
                                    
                                        datateamImproves[i][j].tags[tagId].scorePercentage=(datateamImproves[i][j].tags[tagId].score)/(datateamImproves[i][j].tags[tagId].total*6)*100
                                    }
                                    improves_frequency[j]['tags'].push(...datateamImproves[i][j].tags)
                                }
                               
                                if(datateamImproves[i][j].selected){
                                    for(const k in datateamImproves[i][j].selected){
                                        if(!improves_frequency[j]['selected'][k]){
                                            improves_frequency[j]['selected'][k]=0
                                        }
                                        improves_frequency[j]['selected'][k]=improves_frequency[j]['selected'][k]+datateamImproves[i][j].selected[k]
                                        
                                    }
                                }
                                
                            }

                        }
                    }
                    const max_poing=_.orderBy(skill_frequency,[function (o) {return o.point;},],["desc"])[0];
                    const max_poing_improve=_.orderBy(improves_frequency,[function (o) {return o.point;},],["desc"])[0];
                    for(const i in skill){

                        if(skill_frequency[skill[i]]&&skill_frequency[skill[i]].selected){
                            for(const j in skill_frequency[skill[i]].selected){
                                
                                if(!attributes[skill[i]]){
                                    attributes[skill[i]]=[]
                                }
                                let excelsScore=0
                                if(skill_frequency[skill[i]].selected[j]){
                                 excelsScore=(skill_frequency[skill[i]].selected[j]/skill_frequency[skill[i]].point)*100
                                }
                               
                                let improveScore=0
                           
                                if(improves_frequency[skill[i]]&&improves_frequency[skill[i]].selected[j]){
                                 improveScore=(improves_frequency[skill[i]].selected[j]/improves_frequency[skill[i]].point)*100
                                //  console.log('improveScore===',improves_frequency[skill[i]].selected[j])
                                //  console.log('point',improves_frequency[skill[i]].point)
                                //  console.log('improveScore',improveScore)
                                }
                                
                                attributes[skill[i]].push({
                                    label: j,
                                    excelsScore: Math.round(excelsScore).toFixed(),
                                    couldFurtherImproveScore: Math.round(improveScore).toFixed(),
                                  })
                            }
                        }



                        const  rating_max=215/max_poing.point
                        const  rating_max_dialog=370/max_poing.point
                        const barexcel_width=(skill_frequency[skill[i]]&&skill_frequency[skill[i]].point?skill_frequency[skill[i]].point:0)*rating_max

                        

                        const  rating_max_improves=215/max_poing_improve.point
                        const  rating_max_improves_dialog=370/max_poing_improve.point
                        

                        const barimproves_width=(improves_frequency[skill[i]]?improves_frequency[skill[i]].point:0)*rating_max_improves
                        let _data1:any={
                            name: skill[i],
                            id: skill[i].toLowerCase(),
                            improve:improves_frequency[skill[i]]?improves_frequency[skill[i]].point.toFixed():0,
                            excel:skill_frequency[skill[i]]?skill_frequency[skill[i]].point.toFixed():0,
                            bar_width_excel:barexcel_width.toFixed(),
                            bar_width_improve:barimproves_width.toFixed(),
                            compareexcel:(skill_frequency[skill[i]]?skill_frequency[skill[i]].point:0)-(skill_frequency[skill[i]]?skill_frequency[skill[i]].pastpoint:0),
                            compareimprove:(improves_frequency[skill[i]]?improves_frequency[skill[i]].point:0)-(improves_frequency[skill[i]]?improves_frequency[skill[i]].pastpoint:0),
                            excelsAt:{
                                solid: (skill_frequency[skill[i]]&&skill_frequency[skill[i]].point?skill_frequency[skill[i]].point:0)*rating_max_dialog,
                                gradientFill: 100-10,
                                relative_skill_proficiency_score:10,//relative_skill_proficiency_score.toFixed(1),
                                members:skill_frequency[skill[i]]?skill_frequency[skill[i]].tags:[],
                            },
                            couldFurtherImprove: {
                                solid: isNaN((improves_frequency[skill[i]]?improves_frequency[skill[i]].point:0)*rating_max_improves_dialog)?0:(improves_frequency[skill[i]]?improves_frequency[skill[i]].point:0)*rating_max_improves_dialog,//bar_width_deficiency,
                                gradientFill: 100-23,//bar_width_deficiency,
                                relative_skill_deficiency_score:20,//relative_skill_deficiency_score.toFixed(1),
                                members: improves_frequency[skill[i]]?improves_frequency[skill[i]].tags:[],
                              
                                },
                            }
                            skillProficiencyAndDeficiency.push(_data1)

                    }
                for(const u in userData){
                    if(userData[u].suggest){
                        for(const i in userData[u].suggest){
                            chart[userData[u].suggest[i].suggest]++
                        }
                    }
                   // chart[userData[u].suggest]++}
                   // userData[u].ratingavg=isNaN(userData[u].ratingAll/userData[u].total)?0:(userData[u].ratingAll/userData[u].total).toFixed(1)
                }
                const sort_data_asc=_.orderBy(userData, ['ratingavg','total'], ['asc', 'desc']);
                // _.orderBy(userData,[function (o) {return o.ratingavg;},],["asc"])
                const sort_data_desc= _.orderBy(userData, ['ratingavg','total'], ['desc', 'desc']);
                // _.orderBy(userData,[function (o) {return o.ratingavg;},],["desc"])
               
               
               
                skillProficiencyAndDeficiency=_.orderBy(skillProficiencyAndDeficiency,[function (o) {return o.name;},],["asc"])
                state.statusTeam=true
                
                commit('setskillexcel',_.orderBy(skillProficiencyAndDeficiency,[function (o) {return parseInt(o.excel);},],["desc"]))
                commit('setskillimprove',_.orderBy(skillProficiencyAndDeficiency,[function (o) {return parseInt(o.improve);},],["desc"]))
                commit('setdatachart',[chart['Truly'],chart['Exceeding'],chart['Meets'],chart['Needs']])
                commit('setlowest',sort_data_asc)
                commit('sethighest',sort_data_desc)
                       
                commit('setskillProficiencyAndDeficiency',skillProficiencyAndDeficiency)
                commit('setskillProficiencyAndDeficiencyByteam',skillProficiencyAndDeficiency)
                commit('setAttributes',attributes)
                //commit('setdatachart',data)
                state.loading=false

            }else{
                state.rank=true
                const datateam:any=[]
                const attributes:any={}
                const datateamImproves:any=[]
    
                const company = await getCompany(rootState.authen.user.company)
                const teams = await getTeamByCompany(rootState.authen.user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(rootState.authen.user.company).once('value')).val()
                const allUser = rootState.main.allUser
                const team=state.organization1level[state.teamHeight]
                
                let skillProficiencyAndDeficiency:Array<any>=[]
                let skillData:Array<any>=[]
                const datenow = format(new Date(), 'YYYY-MM-DD');
                const year = format(addMonths(new Date(),-5), 'YYYY-MM');
                const year_1 = format(addMonths(new Date(),-11), 'YYYY-MM');
              
                firebase.firestore().collection('peerfeedback_monthly_team').where('company_id','==',rootState.authen.user.company).get().then(async (querySnapshot)=>{
                    querySnapshot.forEach((doc) => {
                    const data=doc.data()
                    state.dataAllArr.push(data)
                    if(!datateam[data.team_id]){
                        datateam[data.team_id]={total:0}
                    }
                    if(!datateamImproves[data.team_id]){
                        datateamImproves[data.team_id]={total:0}
                    }
                    if(format(data.months,'YYYY-MM-DD')>=year){
                        
                        if(data.excels){
                            let statuscal=true
                            for(const i in data.excels){
                                const excel=data.excels[i]
                                if(!datateam[data.team_id][excel.name]){
                                    datateam[data.team_id][excel.name]={point:0,attributes_selected:0,sum_ratings:0,tags:[],selected:{},pastpoint:0}
                                }
                                datateam[data.team_id][excel.name].point=datateam[data.team_id][excel.name].point+excel.point
                                
                                if(data.excels[i].selected){
                                    for(const j in data.excels[i].selected){
                                        datateam[data.team_id][excel.name].attributes_selected= datateam[data.team_id][excel.name].attributes_selected+data.excels[i].selected[j].point
                                        if(!datateam[data.team_id][excel.name]['selected'][data.excels[i].selected[j].text_en]){
                                            datateam[data.team_id][excel.name]['selected'][data.excels[i].selected[j].text_en]=0
                                        }
                                        datateam[data.team_id][excel.name]['selected'][data.excels[i].selected[j].text_en]=datateam[data.team_id][excel.name]['selected'][data.excels[i].selected[j].text_en]+data.excels[i].selected[j].point
                                    } 
                                }
                                if(data.excels[i].suggest){
                                    
                                    for(const k in data.excels[i].suggest){
                                        for(const l in masterSuggest){
                                            if(data.excels[i].suggest[k][l]){
                                                // console.log("data.excels[i].suggest[k][l]",data.excels[i].suggest[k][l])
                                                // console.log("data.excels[i].suggest[k][l]",data.excels[i].suggest[k][l])
                                                // console.log("total",data.excels[i].suggest[k][l]*masterSuggest[l])
                                                datateam[data.team_id][excel.name].sum_ratings=datateam[data.team_id][excel.name].sum_ratings+(data.excels[i].suggest[k][l]*masterSuggest[l])
                                            }
                                            
                                        }
        
                                        
                                    }
                                }
                                if(data.excels[i].send_to){
                                    
                                    for(const j in data.excels[i].send_to){
                                       
                                        const emailKey= data.excels[i].send_to[j].email_to.replace(/\./g, "||");
                                        const findexcel=_.find(datateam[data.team_id][excel.name].tags, function(o) { return o.id == emailKey; });
                                        
                                        // if(data.excels[i].send_to[j].suggest){
                                        //     chart[data.excels[i].send_to[j].suggest]++
                                        // }
                                        
                                        if(!userData[emailKey]){
                                            if(allUser[emailKey]){
                                                userData[emailKey]={
                                                    company:company.name,
                                                    ratingAll:0,
                                                    ratingavg:0,
                                                    total:0,
                                                    interaction:0,
                                                    ratingavg_sort:0,
                                                    emailKey:emailKey,
                                                    team:allUser[emailKey].team,
                                                    teamname:teams[allUser[emailKey].team].name,
                                                    firstname:allUser[emailKey].firstname,
                                                    lastname:allUser[emailKey].lastname,
                                                    profilepic:allUser[emailKey].profilepic,
                                                    initial:(allUser[emailKey].firstname?allUser[emailKey].firstname.slice(0, 1):'')+(allUser[emailKey].lastname?allUser[emailKey].lastname.slice(0, 1):''),
                                                    suggest:[],//data.excels[i].send_to[j]&&data.excels[i].send_to[j].suggest?data.excels[i].send_to[j].suggest:''
                                                }
                                            }
                                            
                                        }
                                        
                                        
    
                                        if(!findexcel&&allUser[emailKey]){
                                            datateam[data.team_id][excel.name].tags.push({
                                                    name: allUser[emailKey].firstname+" "+allUser[emailKey].lastname,
                                                    id: emailKey,
                                                    teamname:teams[allUser[emailKey].team].name,
                                                    imageProfile:allUser[emailKey].profilepic,
                                                    total:1,
                                                    score:data.excels[i].send_to[j].attribute,
                                                    
                                            })
                                        }else{
                                            if(datateam[data.team_id][excel.name].tags.length>0){
                                                const objIndex = datateam[data.team_id][excel.name].tags.findIndex((obj => obj.id == emailKey))
                                                if(objIndex>-1){
                                                datateam[data.team_id][excel.name].tags[objIndex].score=datateam[data.team_id][excel.name].tags[objIndex].score+data.excels[i].send_to[j].attribute
                                                datateam[data.team_id][excel.name].tags[objIndex].total++
                                                }
                                            }
                                           
                                        }
                                       
                                    }
                                    
                                }
                                
                            }
                           
                        }
        
                        datateam[data.team_id].total+=data.total
                        if(data.improves){
                            if(!datateamImproves[data.team_id]){
                                datateamImproves[data.team_id]={total:0}
                            }
                            for(const i in data.improves){
                                const improves=data.improves[i]
                   
                                if(!datateamImproves[data.team_id][improves.name]){
                                    datateamImproves[data.team_id][improves.name]={point:0,attributes_selected:0,tags:[],selected:{},pastpoint:0}
                                }
                                
                                datateamImproves[data.team_id][improves.name].point++
                                
                                if(data.improves[i].selected){
                                    
                                    for(const j in data.improves[i].selected){
                                        datateamImproves[data.team_id][improves.name].attributes_selected= datateamImproves[data.team_id][improves.name].attributes_selected+data.improves[i].selected[j].point
                                        if(! datateamImproves[data.team_id][improves.name][data.improves[i].selected[j].text_en]){
                                            datateamImproves[data.team_id][improves.name]['selected'][data.improves[i].selected[j].text_en]=0
                                        }
                                        datateamImproves[data.team_id][improves.name]['selected'][data.improves[i].selected[j].text_en]=datateamImproves[data.team_id][improves.name]['selected'][data.improves[i].selected[j].text_en]+data.improves[i].selected[j].point
                                    } 
                                    
        
        
                                }
                                if(data.improves[i].send_to){
                                    for(const j in data.improves[i].send_to){
                                        const emailKey= data.improves[i].send_to[j].email_to.replace(/\./g, "||");
                                        const findImproves=_.find(datateamImproves[data.team_id][improves.name].tags, function(o) { return o.id == emailKey; });
                                        
                                        if(!findImproves && allUser[emailKey]){
                                            datateamImproves[data.team_id][improves.name].tags.push({
                                                    name: allUser[emailKey].firstname+" "+allUser[emailKey].lastname,
                                                    id: emailKey,
                                                    teamname:teams[allUser[emailKey].team].name,
                                                    imageProfile:allUser[emailKey].profilepic,
                                                    scorePercentage: 0,
                                                    total:1,
                                                    score:data.improves[i].send_to[j].attribute
                                            })
                                        }else{
                                            if(datateamImproves[data.team_id][improves.name].tags.length>0){
                                                const objIndex = datateamImproves[data.team_id][improves.name].tags.findIndex((obj => obj.id == emailKey))
                                                if(objIndex>-1){
                                                datateamImproves[data.team_id][improves.name].tags[objIndex].score=datateamImproves[data.team_id][improves.name].tags[objIndex].score+data.improves[i].send_to[j].attribute
                                                datateamImproves[data.team_id][improves.name].tags[objIndex].total++
                                                }
                                            }
                                        }
                                    }
                                    
                                }
                              
                                
                            }
                            
                        }
                        if(data.send_to){
                            const gruopbyData=_.groupBy(data.send_to, function (b) { return b })
                            
                            for(const i in gruopbyData){
                                const emailKey= i.replace(/\./g, "||");
                                if(userData[emailKey]){
                                userData[emailKey].interaction=userData[emailKey].interaction+gruopbyData[i].length
                                }
                            }
                        }
                        if(data.suggest){
                            for(const i in data.suggest){
                                const emailKey= data.suggest[i].email_to.replace(/\./g, "||");
                                if(allUser[emailKey]){
                                    if(!userData[emailKey]){
                                        if(allUser[emailKey]){
                                            userData[emailKey]={
                                                company:company.name,
                                                ratingAll:0,
                                                ratingavg:0,
                                                total:0,
                                                interaction:0,
                                                ratingavg_sort:0,
                                                emailKey:emailKey,
                                                team:allUser[emailKey].team,
                                                teamname:teams[allUser[emailKey].team].name,
                                                firstname:allUser[emailKey].firstname,
                                                lastname:allUser[emailKey].lastname,
                                                profilepic:allUser[emailKey].profilepic,
                                                initial:(allUser[emailKey].firstname?allUser[emailKey].firstname.slice(0, 1):'')+(allUser[emailKey].lastname?allUser[emailKey].lastname.slice(0, 1):''),
                                                suggest:[],//data.excels[i].send_to[j]&&data.excels[i].send_to[j].suggest?data.excels[i].send_to[j].suggest:''
                                            }
                                        }
                                        
                                    }
                                    userData[emailKey].ratingAll=userData[emailKey].ratingAll+(masterSuggest[data.suggest[i].suggest]?masterSuggest[data.suggest[i].suggest]:0)
                                    userData[emailKey].total++
                                    userData[emailKey].suggest.push(data.suggest[i])
                                }
                                chart[data.suggest[i].suggest]++
                            }
                           
                        }


                    }else if(format(data.months,'YYYY-MM-DD')>=year_1){
                        if(data.excels){
                            for(const i in data.excels){
                                const excel=data.excels[i]
                                if(!datateam[data.team_id][excel.name]){
                                    datateam[data.team_id][excel.name]={point:0,attributes_selected:0,sum_ratings:0,tags:[],selected:{},pastpoint:0}
                                }
                                datateam[data.team_id][excel.name].pastpoint=datateam[data.team_id][excel.name].pastpoint+excel.point
                                
                            }
                           
                        }

                        if(data.improves){
                            
                            for(const i in data.improves){
                                const improves=data.improves[i]
                   
                                if(!datateamImproves[data.team_id][improves.name]){
                                    datateamImproves[data.team_id][improves.name]={point:0,attributes_selected:0,tags:[],selected:{},pastpoint:0}
                                }
                                datateamImproves[data.team_id][improves.name].pastpoint=datateamImproves[data.team_id][improves.name].pastpoint+improves.point
  
                                
                                
                                
                              
                                
                            }
                            
                        }


                        
                    }
                    
     
                    })
                    let skill_frequency:any={}
                    const skill:any=[]
                    // console.log('datateam',datateam)
                    let improves_frequency:any={}
                    for(const i in team){
                        //excel
                        if(datateam[i]){
                            for(const j in datateam[i]){
                            if(j!="total"){
                                if(!skill_frequency[j]){
                                    skill_frequency[j]={point:0,attributes_selected:0,sum_ratings:0,tags:[],selected:{},pastpoint:0}
                                }
                                const find=_.find(skill,function(o) { return o == j; });
                                if(!find){
                                skill.push(j)}
                                skill_frequency[j].point=skill_frequency[j].point+datateam[i][j].point
                                skill_frequency[j].attributes_selected=skill_frequency[j].attributes_selected+datateam[i][j].attributes_selected
                                skill_frequency[j].sum_ratings=skill_frequency[j].sum_ratings+datateam[i][j].sum_ratings
                                skill_frequency[j].pastpoint=skill_frequency[j].pastpoint+datateam[i][j].pastpoint
                                // console.log('skill_frequency[j].pastpoint',datateam[i][j].pastpoint)
                            }else{
                                //total_feedback=total_feedback+datateam[i].total
                            }
                            if(datateam[i][j].selected){
                                for(const k in datateam[i][j].selected){
                                    if(!skill_frequency[j]['selected'][k]){
                                        skill_frequency[j]['selected'][k]=0
                                    }
                                    skill_frequency[j]['selected'][k]=skill_frequency[j]['selected'][k]+datateam[i][j].selected[k]
                                    
                                }
                            }
                            if(datateam[i][j].tags){
                                for(const tagId in datateam[i][j].tags){
                                    datateam[i][j].tags[tagId].scorePercentage=(datateam[i][j].tags[tagId].score)/(datateam[i][j].tags[tagId].total*6)*100
                                }
                                skill_frequency[j]['tags'].push(...datateam[i][j].tags)
                            }

                         }

                        }
                        //improves
                        if(datateamImproves[i]){
                            for(const j in datateamImproves[i]){
                                if(j!="total"){
                                    if(!improves_frequency[j]){
                                        improves_frequency[j]={point:0,attributes_selected:0,tags:[],selected:{},pastpoint:0}
                                    }
                                    const find=_.find(skill,function(o) { return o == j; });
                                    if(!find){
                                        skill.push(j)
                                    }
                                    
                                    improves_frequency[j].point=improves_frequency[j].point+datateamImproves[i][j].point
                                    improves_frequency[j].attributes_selected=improves_frequency[j].attributes_selected+datateamImproves[i][j].attributes_selected
                                    improves_frequency[j].pastpoint=improves_frequency[j].pastpoint+datateamImproves[i][j].pastpoint
                                }
                                
                                if(datateamImproves[i][j].tags){
                                  
                                    for(const tagId in datateamImproves[i][j].tags){
                                    
                                        datateamImproves[i][j].tags[tagId].scorePercentage=(datateamImproves[i][j].tags[tagId].score)/(datateamImproves[i][j].tags[tagId].total*6)*100
                                    }
                                    improves_frequency[j]['tags'].push(...datateamImproves[i][j].tags)
                                }
                               
                                if(datateamImproves[i][j].selected){
                                    for(const k in datateamImproves[i][j].selected){
                                        if(!improves_frequency[j]['selected'][k]){
                                            improves_frequency[j]['selected'][k]=0
                                        }
                                        improves_frequency[j]['selected'][k]=improves_frequency[j]['selected'][k]+datateamImproves[i][j].selected[k]
                                        
                                    }
                                }
                                
                            }

                        }



                    }
                    const max_poing=_.orderBy(skill_frequency,[function (o) {return o.point;},],["desc"])[0];
                  
                    const max_poing_improve=_.orderBy(improves_frequency,[function (o) {return o.point;},],["desc"])[0];
                    for(const i in skill){

                        if(skill_frequency[skill[i]]&&skill_frequency[skill[i]].selected){
                            for(const j in skill_frequency[skill[i]].selected){
                                
                                if(!attributes[skill[i]]){
                                    attributes[skill[i]]=[]
                                }
                                let excelsScore=0
                                if(skill_frequency[skill[i]].selected[j]){
                                 excelsScore=(skill_frequency[skill[i]].selected[j]/skill_frequency[skill[i]].point)*100
                                }
                                let improveScore=0
                           
                                if(improves_frequency[skill[i]]&&improves_frequency[skill[i]].selected[j]){
                                 improveScore=(improves_frequency[skill[i]].selected[j]/improves_frequency[skill[i]].point)*100
                                 
                                }
                                attributes[skill[i]].push({
                                    label: j,
                                    excelsScore: Math.round(excelsScore).toFixed(),
                                    couldFurtherImproveScore: Math.round(improveScore).toFixed(),
                                  })
                            }
                        }







                        const  rating_max=215/max_poing.point
                        const  rating_max_dialog=370/max_poing.point
                       
                        const barexcel_width=(skill_frequency[skill[i]]&&skill_frequency[skill[i]].point?skill_frequency[skill[i]].point:0)*rating_max


                        const  rating_max_improves=215/max_poing_improve.point
                        const  rating_max_improves_dialog=370/max_poing_improve.point
                      

                        const barimproves_width=(improves_frequency[skill[i]]?improves_frequency[skill[i]].point:0)*rating_max_improves
                        let _data1:any={
                            name: skill[i],
                            id: skill[i].toLowerCase(),
                            improve:improves_frequency[skill[i]]?improves_frequency[skill[i]].point.toFixed():0,
                            excel:skill_frequency[skill[i]]?skill_frequency[skill[i]].point.toFixed():0,
                            bar_width_excel:barexcel_width.toFixed(),
                            bar_width_improve:barimproves_width.toFixed(),
                            compareexcel:(skill_frequency[skill[i]]?skill_frequency[skill[i]].point:0)-(skill_frequency[skill[i]]?skill_frequency[skill[i]].pastpoint:0),
                            compareimprove:(improves_frequency[skill[i]]?improves_frequency[skill[i]].point:0)-(improves_frequency[skill[i]]?improves_frequency[skill[i]].pastpoint:0),
                            excelsAt:{
                                solid: (skill_frequency[skill[i]]&&skill_frequency[skill[i]].point?skill_frequency[skill[i]].point:0)*rating_max_dialog,
                                gradientFill: 100-10,
                                relative_skill_proficiency_score:10,//relative_skill_proficiency_score.toFixed(1),
                                members:skill_frequency[skill[i]]?skill_frequency[skill[i]].tags:[],
                            },
                            couldFurtherImprove: {
                                solid: isNaN((improves_frequency[skill[i]]?improves_frequency[skill[i]].point:0)*rating_max_improves_dialog)?0:(improves_frequency[skill[i]]?improves_frequency[skill[i]].point:0)*rating_max_improves_dialog,//bar_width_deficiency,
                                gradientFill: 100-23,//bar_width_deficiency,
                                relative_skill_deficiency_score:20,//relative_skill_deficiency_score.toFixed(1),
                                members: improves_frequency[skill[i]]?improves_frequency[skill[i]].tags:[],
                              
                                },
                            }
                            skillProficiencyAndDeficiency.push(_data1)

                    }
        


                        for(const u in userData){
                            userData[u].ratingavg=isNaN(userData[u].ratingAll/userData[u].total)?0:(userData[u].ratingAll/userData[u].total).toFixed(1)
                            userData[u].ratingavg_sort=isNaN(userData[u].ratingAll/userData[u].total)?0:(userData[u].ratingAll/userData[u].total)
                        }
                        const sort_data_asc=_.orderBy(userData, ['ratingavg_sort','total'], ['asc', 'asc']);

                        const sort_data_desc= _.orderBy(userData, ['ratingavg_sort','total'], ['desc', 'desc']);
                        let _count=0
                        let count=0
                        
                        for(const j in sort_data_asc){
                            _count++
                            sort_data_asc[j].rank_lowest=_count
                        }  
                       
                        for(const j in sort_data_desc){
                            count++
                            sort_data_desc[j].rank_highest=count
                        } 
                      
                        
                       
                        state.userData=userData
                        skillProficiencyAndDeficiency=_.orderBy(skillProficiencyAndDeficiency,[function (o) {return o.name;},],["asc"])
                        commit('setskillProficiencyAndDeficiency',skillProficiencyAndDeficiency)
                        commit('setskillexcel',_.orderBy(skillProficiencyAndDeficiency,[function (o) {return parseInt(o.excel);},],["desc"]))
                        commit('setskillimprove',_.orderBy(skillProficiencyAndDeficiency,[function (o) {return parseInt(o.improve);},],["desc"]))
                        commit('setdatachart',[chart['Truly'],chart['Exceeding'],chart['Meets'],chart['Needs']])
                        skillData=_.orderBy(skillData,[function (o) {return o.type;},],["asc"])
                        commit('setSkill',skillData)
                        commit('setlowest',sort_data_asc)
                        commit('sethighest',sort_data_desc)
                        commit('setskillProficiencyAndDeficiencyAll',skillProficiencyAndDeficiency)
                        commit('setAttributes',attributes)
                        commit('setdataAll',{excel:datateam,improves:datateamImproves})
                        if(rootState.authen.user.user_type == 'leadership'){
                            // console.log('rootState.authen.user.team', rootState.authen.user.team)
                            dispatch("getData", rootState.authen.user.team);
                        }else {
                            state.loading=false
                        }
                })
    
                // })

            }
           
     
           
        },
        

        
        

    },
    getters: {
        datachart : (state:any) => {
            return state.datachart
          },
        max_x : (state:any) => {
            return state.max_x
        },
        max_y : (state:any) => {
            return state.max_y
        },
        skillProficiencyAndDeficiency:(state:any) => {
            return state.skillProficiencyAndDeficiency
        },
        checkedSkillTypeOption:(state:any) => {
            return state.skill
        },
        attributes:(state:any) => {
            return state.attributes
        },
        loading:(state:any) => {
            return state.loading
        },
        lowest:(state:any) => {
            return state.lowest
        },
        highest:(state:any) => {
            return state.highest
        },
        skillexcel:(state:any) => {
            return state.skillexcel
        },
        skillimpoves:(state:any) => {
            return state.skillimprove
        }
        

    }
}